import { FunctionalComponent, h } from '@stencil/core';
import state from '@ugc-store';
import { PageType } from '@ugc-utils/utils';

const ViewDesktop: FunctionalComponent<{ productId: number }> = ({ productId }) => {
  const {
    qnaStaticLanguage: { IDS_UGC_QNA_MODULE_TITLE = '' },
    isQnaLoading,
  } = state;

  return (
    <div class="ugc-global-css-wrap">
      {/* "ugc-pdp-qna-section" is used for ga ,could not change */}
      <div class="ugc-pdp-question-and-answer-desktop-box ugc-pdp-qna-section ugc-component-wrap">
        {isQnaLoading && <ugc-loading />}

        <ugc-title size={24} text={IDS_UGC_QNA_MODULE_TITLE} data-testid="pdp-qna-title" />
        <ugc-page-summary pageType={PageType.qna} productId={productId} />
        <ugc-qna-filter productId={productId} />
        <ugc-qna-list productId={productId} />
        <ugc-qna-no-data />

        <ugc-qna-scroll-ga />

        <ugc-qna-answer-modal />
        <ugc-qna-ask-question-modal />
        <ugc-qna-view-more-answers-modal />
        <ugc-qna-sort-filter-modal />
      </div>
    </div>
  );
};

export default ViewDesktop;
